import React, { useRef } from "react";
import "./index.scss";
import { FormGroup } from "reactstrap";
import { Button, Icon } from "shared";

type CustomFileInputProps = {
  style?: any;
  labelText: string;
  attribute: string;
  data: any;
  callback: (attribute: string, value: any) => void;
};

const CustomFileInput = ({
  style,
  labelText,
  attribute,
  data,
  callback,
}: CustomFileInputProps) => {
  const inputRef = useRef<any>();
  const value = data?.[attribute];
  const chooseFile = () => inputRef.current.click?.();
  const renderBody = () => {
    if (!value?.file && !value?.file_url)
      return <Button size="small" label="Chọn file" onClick={chooseFile} />;
    if (
      value?.file?.type?.includes("image") ||
      value?.file_type?.includes("image")
    ) {
      return (
        <div className="image-file-wrapper">
          <div className="normal-button" onClick={chooseFile}>
            <img
              className="image-file"
              src={
                value?.file ? URL.createObjectURL(value?.file) : value?.file_url
              }
            />
          </div>
          <div className="btn-remove">
            <Icon
              name="close"
              size="medium"
              onClick={() => {
                callback(attribute, {
                  file: null,
                  id: value?.id || value?.prevId,
                });
              }}
            />
          </div>
        </div>
      );
    }
    if (
      value?.file?.type?.includes("application") ||
      value?.file_type?.includes("application")
    )
      return (
        <div className="image-file-wrapper">
          <Button
            size="small"
            label={value?.file?.name || value?.file_name}
            onClick={chooseFile}
          />
          <div className="btn-remove">
            <Icon
              name="close"
              size="medium"
              onClick={() => {
                callback(attribute, {
                  file: null,
                  id: value?.id || value?.prevId,
                });
              }}
            />
          </div>
        </div>
      );
  };
  return (
    <div className="custom-attribute__text-input" style={style}>
      <span className="custom-attribute__text-input-label">{labelText}</span>
      <FormGroup>{renderBody()}</FormGroup>
      <input
        ref={inputRef}
        className="choose-file"
        type="file"
        accept="image/*,application/*"
        onChange={(e) => {
          const file = e.target.files?.item(0);
          callback(attribute, { file, prevId: value?.id });
        }}
      />
    </div>
  );
};

export default CustomFileInput;
